<template>
  <div class="library-card-view">
    <page-header :breadcrumbs="breadcrumbs" />
    <deck-page
      v-if="!card"
      :deck="deck"
      @begin-series="beginSeries"
      @card-row-clicked="goToCard"
      @continue-series="continueSeries"
      @restart-series="restartSeries"
    ></deck-page>
    <component
      :is="componentName"
      v-if="card"
      :asset="libraryCardAsset"
      :attachment="libraryCardAsset"
      :content-source="contentSource"
      :display-attachment="displayAttachment"
      :show-asset-recommendations="true"
      :total-views="totalViews"
    />
    <deck-page-footer
      :card="card"
      :deck="deck"
      :show-bookmark="!!card"
      @go-to-next="goToCard"
      @go-to-previous="goToCard"
    />
  </div>
</template>

<script>
import AttachmentPage from '@/components/attachments/page.vue';
import DeckPage from '@components/decks/page.vue';
import DeckPageFooter from '@components/decks/footer.vue';
import LibraryTopic from '@/components/library/topic';
import PageHeader from '@components/singletons/pageHeader.vue';

import AssetPageMixin from '@/mixins/asset-page';
import CardMixin from '@/mixins/card';
import GlobalMixin from '@/mixins/global';
import LibraryMixin from '@/mixins/library';

export default {
  name: 'LibraryCardView',
  components: { AttachmentPage, DeckPage, DeckPageFooter, LibraryTopic, PageHeader },
  mixins: [AssetPageMixin, CardMixin, GlobalMixin, LibraryMixin],
  computed: {
    assetId() {
      if (this.card) {
        return this.card.assetId;
      }
    },
    assetType() {
      if (this.card) {
        return this.card.assetType;
      }
    },
    breadcrumbs() {
      const crumbs = [...this.libraryBreadcrumbs,
        {
          name: this.deck.title,
          route: {
            ...this.deck.libraryRoute,
            query: this.$route.query,
          },
        },
      ];
      if (this.libraryCardAsset) {
        crumbs.push({
          name: this.libraryCardAsset.assetTitle,
          route: {
            name: 'library#card',
            params: {
              deckId: this.deck.id,
              cardId: this.card.id,
            },
            query: this.$route.query,
          },
        });
      }
      return crumbs;
    },
    card() {
      if (this.deck && this.$route.params.cardId) {
        return this.deck.cards.find(card => card.id === Number(this.$route.params.cardId));
      }
    },
    libraryCardAsset() {
      if (this.assetType && this.assetId) {
        return this.assetByAssetType(this.assetType, this.assetId);
      }
    },
    cards() {
      if (this.deck) {
        return [...this.deck.cards].sort((a, b) => a.order - b.order);
      } else {
        return [];
      }
    },
    componentName() {
      if (this.card) {
        if (this.card.assetType === 'Attachment') {
          return 'attachment-page';
        } else {
          return `Library${this.card.assetType}`;
        }
      }
    },
    deck() {
      return this.$store.getters['decks/get'][this.$route.params.deckId];
    },
  },
  created() {
    this.$watch('deck', (newDeck, oldDeck) => {
      if (newDeck && newDeck.id !== oldDeck?.id) {
        newDeck.fetchAssets(this.$store);
      }
    }, { immediate: true });
  },
  mounted() {
    this.$store.dispatch('flashcardStates/fetchStates', ['attachments', 'bookmarks', 'flashcards', 'learning_modules', 'topics']);
  },
  methods: {
    beginSeries() {
      this.$router.push({
        name: 'library#card',
        params: {
          deckId: this.deck.id,
          cardId: this.cards[0].id,
        },
        query: { ...this.$route.query },
      });
    },
    goToCard(card) {
      const route = {
        name: 'library#card',
        query: { ...this.$route.query },
      };
      if (card.assetType === 'Deck') {
        route.params = {
          deckId: card.id,
        };
      } else {
        route.params = {
          deckId: this.deck.id,
          cardId: card.id,
        };
      }
      this.$router.push(route);
    },
  },
};
</script>
